export default "__VITE_ASSET__f6d91696__"